type FilterPillsProps<T extends string> = {
  options: ReadonlyArray<{ id: T; label: string }>
  value: T | null
  onChange: (value: T) => void
  /** Background color for the active pill. Defaults to the brand red-orange. */
  activeColor?: string
}

export function FilterPills<T extends string>({
  options,
  value,
  onChange,
  activeColor = 'rgb(229, 83, 61)',
}: FilterPillsProps<T>) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {options.map((option) => {
        const isSelected = option.id === value
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => onChange(option.id)}
            className={[
              'rounded-full px-2 !py-[1px] !text-[12px] font-normal transition-colors',
              isSelected
                ? '!font-semibold text-white'
                : 'border border-gray-300 text-gray-700 hover:bg-gray-50',
            ].join(' ')}
            style={isSelected ? { backgroundColor: activeColor } : undefined}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
